<template>
  <OrganizationVisitType :organizationId="organizationId"></OrganizationVisitType>
</template>
<script>
import { xray } from "../../../../config/pluginInit";
import OrganizationVisitType from "../../../../components/organization/OrganizationVisitType";

import utilsService from "../../../../services/utils";

export default {
  name: "VisitType",
  mounted() {
    xray.index();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_VISIT_TYPES", info: "" });
  },
  computed: {},
  methods: {},
  data() {
    return {
      organizationId: localStorage.getItem("organizationId"),
    };
  },
  components: {
    OrganizationVisitType,
  },
};
</script>
